/** Minimal Server-Sent Events frame parser. */

export interface SseEvent {
  event: string;
  data: unknown;
}

export function createSseParser(onEvent: (e: SseEvent) => void) {
  let buffer = '';

  function emitFrame(rawFrame: string) {
    let event = 'message';
    const dataLines: string[] = [];

    for (const line of rawFrame.split('\n')) {
      // ":" prefixed lines are comments (our heartbeat) -- ignore them.
      if (!line || line.startsWith(':')) continue;
      if (line.startsWith('event:')) {
        event = line.slice(6).trim();
      } else if (line.startsWith('data:')) {
        dataLines.push(line.slice(5).replace(/^ /, ''));
      }
    }

    if (!dataLines.length) return;
    const raw = dataLines.join('\n');
    try {
      onEvent({ event, data: JSON.parse(raw) });
    } catch {
      // The server always sends JSON; anything else is a bug or a truncated
      // frame. Surface it as text rather than throwing mid-stream.
      onEvent({ event, data: raw });
    }
  }

  function feed(chunk: string) {
    buffer += chunk;

    // Frames are separated by a blank line. Normalise CRLF first so a server
    // or proxy that uses \r\n doesn't break parsing.
    buffer = buffer.replace(/\r\n/g, '\n');

    let idx: number;
    while ((idx = buffer.indexOf('\n\n')) !== -1) {
      emitFrame(buffer.slice(0, idx));
      buffer = buffer.slice(idx + 2);
    }
  }

  /** Deliver whatever is still buffered. */
  function flush() {
    const rest = buffer.trim();
    buffer = '';
    if (rest) emitFrame(rest);
  }

  return { feed, flush };
}
